var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8116 11.5839C18.8093 10.953 18.7304 10.3247 18.5767 9.71284L20.9554 7.97229L19.0872 4.74357L16.3981 5.93874C15.4861 5.06035 14.3739 4.41716 13.1577 4.06475L12.8474 1.14062H9.12257L8.79767 4.06475C7.58147 4.41716 6.46934 5.06035 5.55734 5.93874L2.86819 4.74357L1 7.98099L3.37875 9.72154C3.0693 10.9497 3.0693 12.2355 3.37875 13.4637L1 15.2043L2.86819 18.4243L5.55734 17.2291C6.47003 18.1081 7.58324 18.7513 8.80057 19.1031L9.12257 22.0272H12.8474L13.1577 19.1031C14.3739 18.7507 15.4861 18.1075 16.3981 17.2291L19.0872 18.4243L20.9554 15.1869L18.5767 13.4463C18.7297 12.8373 18.8086 12.2119 18.8116 11.5839ZM10.9792 15.271C10.2498 15.2716 9.53666 15.0558 8.92994 14.651C8.32323 14.2462 7.8502 13.6706 7.57069 12.9969C7.29118 12.3233 7.21775 11.5818 7.35968 10.8664C7.50162 10.151 7.85255 9.49375 8.36808 8.97781C8.88361 8.46187 9.54058 8.11043 10.2559 7.96792C10.9712 7.82542 11.7127 7.89827 12.3866 8.17725C13.0605 8.45623 13.6365 8.92881 14.0417 9.53521C14.447 10.1416 14.6633 10.8546 14.6633 11.5839C14.6633 12.5613 14.2753 13.4987 13.5844 14.1901C12.8936 14.8814 11.9565 15.2702 10.9792 15.271Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageIcon);
export default __webpack_public_path__ + "static/media/manageIcon.c2e1be877863aeb6d117c9f15e9d7b34.svg";
export { ForwardRef as ReactComponent };